import _ from 'lodash'
import Wizard from 'scoreboard/components/wizard'
import DbConnection from 'scoreboard/imports/db-connection'
import DatasetTransformations from './datasets-transformations'
import DatasetsCreateFields from './datasets-create-fields'
import i18n from 'scoreboard/components/i18n'
import Backbone from 'backbone'
import SpreadsheetChooser from 'scoreboard/imports/spreadsheet-chooser'
import WorksheetOptions from 'scoreboard/imports/worksheet-options'
import LabelOwnersSchedule from 'scoreboard/imports/label-owners-schedule'
import appDisplay from 'scoreboard/components/app-display'
import unwrapModel from 'scoreboard/components/unwrap-model'
import RestRequestForm from 'scoreboard/imports/rest/rest-request-form'
import RestDataSelector from 'scoreboard/imports/rest/rest-data-selector'
import constants from 'scoreboard/components/constants'
const { IMPORT_DATA_SOURCE_TYPE } = constants

/** the common views shared by all dataset source types */
const commonViews = [ DatasetTransformations, DatasetsCreateFields,
	LabelOwnersSchedule ]

const dbViews = [ DbConnection ].concat(commonViews)

// views when using a spreadsheet for the data source
const spreadsheetViews =
	[ SpreadsheetChooser, WorksheetOptions ].concat(commonViews)

const restViews = [ RestRequestForm, RestDataSelector ].concat(commonViews)

var DatasetsWizard = Wizard.extend({

	/**
	 * Creates a Dataset from a database or spreadsheet.
	 *
	 * With #44888 the datasets wizard is opened *after* selecting the
	 * data source type
	 *
	 * @constructs
	 *
	 * @param {Object} [options]
	 *
	 * @param {Dataset} options.model the dataset to be built by the wizard, with
	 * the relativeId specified
	 *
	 * @param {Array} options.connections the import connections defined in
	 * admin
	 */
	initialize: function(options) {
		let initialViews
		// determine initial views based on data source type selection
		let model = unwrapModel(this.model)
		let source = _.get(model, 'dataSourceMetadata.source')
		if (source === 'database') {
			initialViews = dbViews
		} else if (source == IMPORT_DATA_SOURCE_TYPE.REST) {
			initialViews = restViews
		} else {
			initialViews = spreadsheetViews
		}
		let opts = _.extend({}, {
			views: initialViews,
			doneKey: 'common.create'
		}, options)
		Wizard.prototype.initialize.call(this, opts)
	},

	next: function(options) {
		this._extendOptions(options)
		let views
		let source = _.get(unwrapModel(this.options.model), 'dataSourceMetadata.source')
		if (source == IMPORT_DATA_SOURCE_TYPE.REST) {
			views = restViews
		} else if (this.options.model.isSpreadsheet()) {
			// #27739 always show worksheet options step for spreadsheets
			views = spreadsheetViews
			if (!this.options.model.isImportConnection()) {
				views = _.without(views, LabelOwnersSchedule)
			}
		} else {
			views = dbViews
		}
		this.setViews(views)
		Wizard.prototype.next.apply(this, arguments)
	},

	// for connection-step1
	title: function() {
		return i18n.get('common.create2', 'datasets.dataset') + ': ' +
			i18n.get('common.add2', 'datasets.connection')
	},

	finish: function() {
		// #14496 important: goes before this.trigger('done') because datasets have
		// some non-standard behavior (e.g. put the nav pane into not-editable
		// mode)
		appDisplay.navView().saveTransient(this.options.model.get('relativeId'),
			this.options.model.attributes)
		Backbone.trigger('add:domain-object', this.options.model,
			this.options.relativeId)
		this.trigger('done')
	}

})

export default DatasetsWizard

DatasetsWizard.__filename__ = 'datasets/edit/datasets-wizard.js'
